import { styled } from 'components/ThemeConfigConnector/ThemeConfigConnnector';
import { Breakpoints, MQ } from 'style/styled-components/cssMediaQueries';
import { fontBold, fontExtraBold } from 'style/styled-components/cssGlobalVariables';
import Button from 'components/Buttons/Button/Button';
import { ButtonInner } from 'components/Buttons/Button/Button.css';
import { buttonReset } from 'style/styled-components/cssButtonReset';

export const ModalDetails = styled.div`
    position: absolute;
    text-align: center;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    padding: 0 16px;

    ${MQ(Breakpoints.s)} {
        width: 440px;
        padding: 0;
    }
`;

export const ModalTitle = styled.h2`
    margin: 0;
    font-size: 32px;
    font-weight: normal;
    padding-bottom: 16px;
    line-height: 40px;
    width: 100%;
    font-family: ${fontExtraBold};
    color: ${(props) => props.theme.brandedConfig.high_contrast};
`;

export const ModalText = styled.p`
    color: ${(props) => props.theme.brandedConfig.high_contrast};
    font-size: 16px;
    line-height: 24px;
    padding-bottom: 24px;
    opacity: 0.7;
`;

export const LockedPinCounter = styled.span`
    font-family: ${fontBold};
    color: ${(props) => props.theme.brandedConfig.high_contrast};
    font-size: 64px;
`;

export const ResetContainer = styled.div`
    position: absolute;
    bottom: 24px;
    left: 16px;
    width: calc(100% - 32px);
    margin-top: 30px;
    display: block;

    ${MQ(Breakpoints.xs)} {
        display: none;
    }
`;

export const ResetButton = styled(Button)`
    font-family: ${fontBold};
    width: 100%;

    ${ButtonInner} {
        display: inline-block;
        width: 100%;
    }

    ${MQ(Breakpoints.xs)} {
        width: auto;
    }
`;

export const HintText = styled.p`
    color: ${(props) => props.theme.brandedConfig.high_contrast};
    font-size: 14px;
    line-height: 20px;
    opacity: 0.7;
    text-align: center;
    margin-bottom: 16px;
    margin-top: 16px;
`;

export const ModalContentWrapper = styled.div`
    color: ${(props) => props.theme.brandedConfig.high_contrast};

    ${ResetContainer} {
        display: none;
    }

    ${MQ(Breakpoints.xs)} {
        ${ResetContainer} {
            display: block;
            width: auto;
            position: static;

            ${ResetButton} {
                ${ButtonInner} {
                    width: auto;
                }
            }
        }
    }
`;

const NavigationIcon = styled.button`
    ${buttonReset}
    cursor: pointer;

    &:hover {
        background: var(--color-dark-foreground-15);

        svg {
            color: var(--color-main-white);
        }
    }

    &:focus-visible {
        outline: var(--focus-outline);
    }
`;

export const BackButton = styled(NavigationIcon)`
    position: absolute;
    left: 16px;
    top: 6px;
    background: var(--color-dark-foreground-5);
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;

    ${MQ(Breakpoints.s)} {
        top: 16px;
        left: 26px;
    }

    ${MQ(Breakpoints.m)} {
        left: 46px;
    }

    svg {
        width: 18px;
        height: 18px;
        margin-top: 2px;
        margin-left: -2px;
    }
`;

export const ErrorLabel = styled.div`
    display: flex;
    align-items: center;
    text-align: left;
    line-height: 1.2;
    font-size: 14px;
    gap: 8px;
    width: 100%;
    max-width: 400px;
    padding: 8px 16px 8px 8px;
    margin: 0 auto 24px;
    border-radius: 4px;
    background: var(--color-dark-foreground);
    color: var(--color-primary);

    .SVGInline {
        display: flex;
        flex-shrink: 0;
    }
`;
